export const featureData = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    iconName: 'SparklesIcon',
    features: [
      { id: 'dashboard-Dashboard', label: 'Dashboard', tooltip: 'Charts and Analytics', iconName: 'WrenchScrewdriverIcon', toolboxRole: 'admin' },
      { id: 'dashboard-Dashboard', label: 'Dashboard', tooltip: 'Charts and Analytics', iconName: 'WrenchScrewdriverIcon', toolboxRole: 'netzoom' },
      { id: 'dashboard-Dashboard', label: 'Dashboard', tooltip: 'Charts and Analytics', iconName: 'WrenchScrewdriverIcon', toolboxRole: 'vss' }
    ]
  },
  {
    id: 'netzoom',
    label: 'NetZoom',
    iconName: 'HomeIcon',
    features: [
      { id: 'netzoom-NetZoomClients',     label: 'Authorize NetZoom Clients', tooltip: 'Manage NetZoom clients and users', iconName: 'ShieldCheckIcon',        toolboxRole: 'admin' },
      { id: 'netzoom-DeviceLibraryBucket', label: 'Device Library',           tooltip: 'Manage Device Library',          iconName: 'Cog6ToothIcon',           toolboxRole: 'admin' },
      { id: 'netzoom-DeviceLibraryBucket', label: 'Device Library',           tooltip: 'Manage Device Library',          iconName: 'Cog6ToothIcon',           toolboxRole: 'netzoom' },
      { id: 'netzoom-VisioStencilsBucket', label: 'Visio Stencils',           tooltip: 'Manage Visio Stencils',          iconName: 'Cog6ToothIcon',           toolboxRole: 'admin' },
      { id: 'netzoom-VisioStencilsBucket', label: 'Visio Stencils',           tooltip: 'Manage Visio Stencils',          iconName: 'Cog6ToothIcon',           toolboxRole: 'vss' }
    ]
  },
  {
    id: 'emtools',
    label: 'EMTools',
    iconName: 'SparklesIcon',
    features: [
      { id: 'emtools-EMTools', label: 'EMTools', tooltip: 'Create NetZoom Database skeleton', iconName: 'WrenchScrewdriverIcon', toolboxRole: 'admin' },
      { id: 'emtools-EMTools', label: 'EMTools', tooltip: 'Create NetZoom Database skeleton', iconName: 'WrenchScrewdriverIcon', toolboxRole: 'netzoom' }
    ]
  },
  {
    id: 'email',
    label: 'Email Client',
    iconName: 'SparklesIcon',
    features: [
      { id: 'email-EmailClient', label: 'Email Client', tooltip: 'Email Client', iconName: 'WrenchScrewdriverIcon', toolboxRole: 'admin' }
    ]
  },
  {
    id: 'twilio',
    label: 'Twilio SMS Client',
    iconName: 'SparklesIcon',
    features: [
      { id: 'twilio-TwilioClient', label: 'Twilio SMS Client', tooltip: 'Twilio SMS Client', iconName: 'WrenchScrewdriverIcon', toolboxRole: 'admin' }
    ]
  }
] as const;
